// extracted by mini-css-extract-plugin
export default {"list":"gift_list__56BC8"};